<template>
  <div class="blog-page__header">
    <div class="container">
      <h1 class="blog-page__title">Journal</h1>
      <p class="blog-page__description">
        In an ideal world we’d be beach-side and sun-kissed all year round but
        the reality of day-to-day life means having to sartorially tackle the
        changing seasons. So, what to do if you’re dressing for plunging
        temperatures and city streets right now, but you still want to deploy
        your most-loved R&B pieces? We’ll help with some layering tips and
        sartorial tricks.
      </p>
    </div>
  </div>
  <div class="container">
    <BlogTypes
      :types="journalTypes"
      :selected-type="selectedType"
      @change="(val) => (selectedType = val)"
    />
  </div>
  <div class="blog-grid container container--flush">
    <JournalTile
      v-for="entry in journalEntries"
      :key="entry.id"
      :entry="entry"
    />
  </div>
</template>

<script>
import BlogTypes from "@/components/journal/BlogTypes.vue";
import JournalTile from "@/components/journal/JournalTile";
import journalQuery from "@/graphql/queries/JournalPage.gql";
import { unwrapNodes } from "@/helpers/graphql";
import { RelayConnection } from "@/helpers/pagination";

export default {
  name: "BlogPage",
  components: {
    JournalTile,
    BlogTypes,
  },
  data() {
    return {
      journal: {
        articles: new RelayConnection(),
      },
      selectedType: null,
      journalTypes: [],
    };
  },
  computed: {
    journalEntries() {
      return unwrapNodes(this.journal.articles?.edges);
    },
  },
  watch: {
    journalEntries(_, oldVal) {
      // Set journal types on first journal entries load
      if (oldVal.length === 0) {
        this.setJournalTypes();
      }
    },
  },
  methods: {
    setJournalTypes() {
      // Get an array of every tag
      let arrayOfTypes = [];
      this.journalEntries.forEach(({ tags }) => {
        arrayOfTypes = [...arrayOfTypes, ...tags];
      });

      // Make a map of unique values and their count
      const uniqueAndCount = new Map();
      arrayOfTypes.forEach((tag) => {
        uniqueAndCount.set(tag, 1 + (uniqueAndCount.get(tag) || 0));
      });

      // Convert map to an array of objects
      const valuesAndCount = [...uniqueAndCount].map(([key, value]) => ({
        label: key,
        count: value,
      }));

      this.journalTypes = valuesAndCount.sort((a, b) =>
        a.label.localeCompare(b.label)
      );
    },
  },
  apollo: {
    journal: {
      query: journalQuery,
      variables() {
        return {
          query: this.selectedType ? "tag:" + this.selectedType : null,
        };
      },
      update: (data) => {
        return data.blog;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-page__header {
  background-color: $color-light;
  padding: 60px 20px;

  @include respond-above(md) {
    padding: 80px 40px;
  }
}

.blog-page__title {
  text-transform: uppercase;
  font-size: 18px;
  font-weight: normal;

  @include respond-above(md) {
    font-size: 30px;
  }
}

.blog-page__description {
  margin-top: 10px;
  font-size: 14px;
  font-family: $heading-font-family;

  @include respond-above(md) {
    font-size: 18px;
    max-width: 60%;
  }
}

.blog-grid {
  display: grid;
  gap: 2px;

  @include respond-above(md) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2px;
  }
}
</style>
